import { combineInterceptors } from './interceptor';
import { httpInterceptor } from './interceptor-http';

export const appInterceptor = combineInterceptors([httpInterceptor]);
